import React from 'react';
import './Main.css';
import LessonInfo from './LessonInfo';
import CurseInfo from './CurseInfo';

function Main() {
    return (
        <div className="main">
         <LessonInfo/>
        </div>
            
    )
}

export default Main
